export class SnapshotRecipeInvalidSnapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "SnapshotRecipeInvalidReason",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeInvalidSnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
